/**
 * @fileoverview Shared utility functions.
 */

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

/**
 * Merge Tailwind CSS class names with conflict resolution.
 * Combines clsx (conditional classes) with tailwind-merge (deduplication).
 *
 * @param {...(string|object|Array)} inputs - Class names, objects, or arrays to merge.
 * @returns {string} The merged class string.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
